import * as React from 'react'

const SlidePaginationButton = ({ index, slideIndex, setSlideIndex, }) => {
  function handleClick() { setSlideIndex(index) }

  const isCurrentSlide = slideIndex === index

  return (
    <li>
      <button
        aria-current={isCurrentSlide ? 'step' : undefined}
        aria-label={isCurrentSlide ? `Current slide: ${index + 1}` : `Go to slide ${index + 1}`}
        className='slide-pagination-button focus-on-light'
        onClick={handleClick}
        type="button"
      />
    </li>
  )
}

export default SlidePaginationButton
